<template>
  <div>
    <div @click="inputFocus" class="my-reply">
    </div>
    <div style="clear: both"></div>
    <div v-for="(item, i) in comments" :key="i" class="author-title reply-father" :class="i===0?'comment_border':''" style="margin:0 10px 0 10px;">
      <el-avatar class="header-img" :size="40" :src="item.fileImg" :key="item.fileImg"></el-avatar>
      <div class="author-info" @click="commentAction(item.id,true,item.creatorId)">
        <span class="author-name">{{ item.creatorName }}</span>
        <div class="talk-box">
          <p>
            <span class="reply">{{ item.gmtCreate }}</span>
          </p>
        </div>
        <span class="author-time" :title='item.content' v-html='item.content'></span>
      </div>
      <div class="reply-box">
        <div :class="item.childrens.length !== 0?'padding_top_5':''">
          <div v-for="(reply, j) in item.childrens" :key="j">
            <div class="author-info" v-if="j < 2" @click="commentAction(reply.id,false,reply.creatorId)">
              <label class="author-name" style="float: left;">{{ reply.creatorName + "：" }}</label>
              <span class="author-time" v-html='reply.content'></span>
            </div>
          </div>
          <div style="padding-bottom:10px" v-if="item.childrens.length > 2" @click="commentPageClick(item.id,item.childrens.length)">
            <span class="author-time commentPage">共{{item.childrens.length}}条回复 ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="comment commentbut" style="margin-top: 14px;margin-left:10px;display: flex" v-show="!pushShow" @click="openComent()">
      <el-avatar class="header-img" :size="40" :src='logo'></el-avatar>
      <div class="reply-info" style="margin-left:19px">
        <div tabindex="0" contenteditable="true" id="replyInput" spellcheck="false" placeholder="请评论..." class="reply-input"></div>
      </div>
    </div>
    <div class="wrapper" @click.stop :class="pushShow?'write-phonenum-1000':''">
      <div class="comment" style="margin-top: 7px;background:white;">
        <el-avatar class="header-img" :size="40" :src='logo'></el-avatar>
        <textarea style="padding:10px" id="comentText" ref="Inp" v-model="value">
        </textarea>
        <span @click="blurComent()" style="margin-right: 5px;color: red;">取消</span>
        <span @click="tapToSearch()">发送</span>
      </div>
    </div>
    <van-popup v-model="popupShow" position="bottom" :style="{ height: 'auto' }">
      <div class="delComent" v-if="delComment">
        <span>删除评论后，评论下所有的回复都会被删除</span>
      </div>
      <div class="delComent" @click="replyCommentAction()" v-if="noComment && !delComment">
        <span class="reply">回复</span>
      </div>
      <div class="delComent" @click="delCommentAction()" v-if="noDelete">
        <span class="del">删除评论</span>
      </div>
      <div class="delComent" @click="cancle()" v-if="!delComment">
        <span class="reply">取消</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
const clickoutside = {
  // 初始化指令
  bind (el, binding, vnode) {
    function documentHandler (e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update () {},
  unbind (el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside);
    delete el.vueClickOutside;
  }
};
export default {
  name: 'ArticleComment',
  props: {
    datainfo: {}
  },
  data () {
    return {
      index: '0',
      replyComment: '',
      commentId: 0,
      deleteSure: false,
      msgData: {
        title: '提示信息',
        msg: '是否确认删除？'
      },
      caseID: Number,
      comments: [],
      popupShow: false,
      noComment: true,
      noDelete: true,
      delComment: false,
      value: '',
      pushShow: false,
      logo: '',
      parentId: 0
    };
  },
  directives: { clickoutside },
  created () {
    if (this.$route.query.caseid) {
      this.caseID = this.$route.query.caseid;
    }
    this.getCommentList();
    setTimeout(() => {
      if (this.$store.state.userInfo.headimg) {
        this.logo =
          this.utils.getFileUrl(Number(this.$store.state.userInfo.headimg))
      } else {
        this.logo = require('../../../assets/headimg.png');
      }
    });
  },
  methods: {
    getCommentList () {
      this.$axios
        .post('edu/comment/list', {
          version: this.$version,
          data: {
            dataId: this.datainfo.dataId,
            moduleId: this.datainfo.moduleId,
            platformId: Number(this.$store.state.userInfo.platformId)
          }
        })
        .then((res) => {
          const commentPageData = [];
          if (res.status && res.data.length) {
            res.data.forEach((a) => {
              a.inputShow = false;
              if (a.creatorHeaderImg) {
                a.fileImg =
                  this.utils.getFileUrl(Number(a.creatorHeaderImg))
              } else {
                a.fileImg = require('../../../assets/headimg.png');
              }
              a.childrens.forEach((b) => {
                b.inputShow = false;
                if (b.creatorHeaderImg) {
                  b.fileImg =
                    this.utils.getFileUrl(Number(b.creatorHeaderImg))
                } else {
                  b.fileImg = require('../../../assets/headimg.png');
                }
              });
            });
            this.comments = res.data;
          } else {
            res.data.forEach((a) => {
              a.inputShow = false;
              if (a.creatorHeaderImg) {
                a.fileImg =
                  this.utils.getFileUrl(Number(a.creatorHeaderImg))
              } else {
                a.fileImg = require('../../../assets/headimg.png');
              }
              a.childrens.forEach((b) => {
                b.inputShow = false;
                if (b.creatorHeaderImg) {
                  b.fileImg =
                    this.utils.getFileUrl(Number(b.creatorHeaderImg))
                } else {
                  b.fileImg = require('../../../assets/headimg.png');
                }
              });
              commentPageData.push(a);
              commentPageData[0].childrens.forEach((c) => {
                c.inputShow = false;
                if (c.creatorHeaderImg) {
                  c.fileImg =
                    this.utils.getFileUrl(Number(c.creatorHeaderImg))
                } else {
                  c.fileImg = require('../../../assets/headimg.png');
                }
                commentPageData.push(c);
              });
              commentPageData[0].childrens = [];
            });
            this.comments = commentPageData;
          }
        });
    },
    inputFocus () {
      var replyInput = document.getElementById('replyInput');
      replyInput.style.padding = '8px 8px';
      replyInput.focus();
    },
    showReplyInput (i, name, id) {
      this.comments[this.index].inputShow = false;
      this.index = i;
      this.comments[i].inputShow = true;
      this.to = name;
      this.toId = id;
    },
    _inputShow (i) {
      return this.comments[i].inputShow;
    },
    tapToSearch () {
      if (!this.value) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '评论不能为空'
        });
      } else {
        this.$axios
          .post('edu/comment/add', {
            version: this.$version,
            data: {
              content: this.value,
              dataId: this.datainfo.dataId,
              moduleId: this.datainfo.moduleId,
              platformId: Number(this.$store.state.userInfo.platformId),
              parentId: this.parentId > 0 ? this.parentId : 0
            }
          })
          .then((res) => {
            if (res.status) {
              this.parentId = 0;
              this.pushShow = false;
              this.getCommentList();
              this.blurComent();
            }
          });
      }
    },
    blurComent () {
      this.pushShow = false;
      const inputId = document.getElementById('comentText'); // 获取ID
      inputId.blur(); // input失焦
    },
    onDivInput: function (e) {
      this.replyComment = e.target.innerHTML;
    },
    commentAction (id, noComment, createdId) {
      if (Number(createdId) !== Number(this.$store.state.userInfo.id)) {
        this.noDelete = false;
      } else {
        this.noDelete = true;
      }
      this.noComment = noComment;
      if (this.noComment || this.noDelete) {
        this.popupShow = true;
      }
      this.commentId = id;
      this.delComment = false;
    },
    cancle () {
      this.popupShow = false;
    },
    delCommentAction () {
      // this.deleteSure = true;
      if (this.delComment) {
        this.$axios
          .post('edu/comment/delete', {
            version: this.$version,
            data: {
              id: this.commentId
            }
          })
          .then((res) => {
            if (res.status) {
              this.$message({
                message: '删除成功',
                type: 'success',
                duration: $messageDuration
              });
              this.delComment = false;
              this.popupShow = false;
              this.getCommentList();
            }
          });
      } else {
        this.delComment = true;
      }
    },
    replyCommentAction () {
      this.parentId = this.commentId;
      this.popupShow = false;
      this.openComent();
    },
    openComent () {
      this.value = '';
      this.pushShow = true;
      this.$nextTick((x) => {
        // 正确写法
        this.$refs.Inp.focus();
      });
    },
    commentPageClick (id, len) {
      this.$emit('pageAction', id, len);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 60px;
  position: fixed;
  bottom: -1000px;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.08);
  z-index: 1;
  display: none;
}
.write-phonenum-1000 {
  bottom: 18px !important;
  display: block!important;
}
.comment {
  span {
    font-size: 14px;
    color: #478ff8;
    letter-spacing: 0.21px;
    position: relative;
    left: 10px;
    bottom: 0px;
  }
}
.commentbut {
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  background: #fff;
}
#comentText {
  background: #f5f5f5;
  border-radius: 5px;
  border-radius: 5px;
  width: 60%;
  height: 68px;
  position: relative;
  z-index: 1;
  margin-left: 20px;
}
  .reply-info {
    display: inline-block;
    width: 100%;
    height: 100%;
    @media screen and (max-width: 1200px) {
      width: 80%;
    }
    .reply-input {
      border: none;
      height: 100%;
      background: $slightgreyf6;
      border: 1px solid $greye6eefe6;
      margin: 0 0 0 14px;
      padding: 10px 10px;
      color: $grey;
      background-color: $slightgreyf6;
      border-radius: 5px;
      &:empty:before {
        content: attr(placeholder);
      }
      &:focus:before {
        content: none;
      }
      &:focus {
        padding: 8px 8px;
        // border: 2px solid blue;
        box-shadow: none;
        outline: none;
      }
    }
  }
.padding_top_5 {
  padding: 5px 0;
}
.comment_border {
  border-top: 8px solid $slightgreyf8;
  // border-bottom: 8px solid $slightgreyf8 !important;
  // margin: 0 !important;
}
.delComent {
  height: 50px;
  border-bottom: 1px $greyef1 solid;
  span {
    font-family: PingFangSC-Medium;
    font-size: 13px;
    color: $grey;
    text-align: center;
    line-height: 36px;
    display: block;
    text-align: center;
    padding-top: 7px;
  }
  .del {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: $red;
    text-align: center;
    line-height: 36px;
  }
  .reply {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: $grey;
    text-align: center;
    line-height: 36px;
  }
}
.commentPage {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: $blue;
  letter-spacing: 0.21px;
  margin: 6px 0 10px 20px;
}
.my-reply {
  width: 100%;
  // height: 116px;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  // .reply-father{
  //   width:1500px;
  // }
  .reply-btn-box {
    height: 25px;
    margin: 20px 0;
    .reply-btn {
      position: relative;
      float: right;
    }
  }
}
.my-comment-reply {
  margin-left: 50px;
  .reply-input {
    width: flex;
  }
}
.author-title:not(:last-child) {
  border-bottom: 1px solid $slightgreyf8;
  // width:1580px;
}
.author-title {
  padding: 10px 0 10px 10px;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  .author-info {
    display: inline-block;
    margin-left: 20px;
    width: 80%;
    line-height: 30px;
    > span {
      display: block;
      cursor: pointer;
    }
    .author-name {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: $black;
      letter-spacing: 0;
      font-weight: bold;
      line-height: 20px;
      margin: 0 5px 0 0;
    }
    .author-time {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: $black;
      line-height: 20px;
      word-break: break-word;
      white-space: break-spaces;
    }
  }

  .icon-btn {
    width: 30%;
    padding: 0 !important;
    float: right;
    @media screen and (max-width: 1200px) {
      width: 20%;
      padding: 7px;
    }
    > span {
      cursor: pointer;
    }
    .iconfont {
      margin: 0 5px;
    }
  }
  .talk-box {
    height: 16px;
    line-height: 16px;
    margin: 0 0 8px 0;
    > p {
      margin: 0;
    }
    .reply {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: $grey;
      letter-spacing: 0.18px;
      text-align: right;
    }
  }
  .reply-box {
    margin: 10px 0 0 50px;
    background: $greyf7;
  }
}
</style>
